import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function AvisoAfiliacionPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF9F7]">
      <Navbar />
      <main className="pt-36 lg:pt-44 pb-24 lg:pb-32 px-8 md:px-12 lg:px-[8%]">
        <div className="max-w-4xl mx-auto relative">
          <span
            className="absolute -top-4 right-0 text-[140px] lg:text-[180px] font-extrabold text-[#E8DED2]/[0.12] leading-none tracking-[-0.05em] select-none pointer-events-none"
            aria-hidden="true"
          >
            AF
          </span>

          <p className="text-[10px] tracking-[0.35em] uppercase text-[#A39B92] font-medium mb-6">
            LEGAL
          </p>
          <h1 className="text-[clamp(2.5rem,5vw,4rem)] font-bold text-[#111111] leading-tight tracking-[-0.02em] mb-3">
            Aviso de Afiliación
          </h1>
          <div className="w-14 h-[2px] bg-[#D4B896] mb-16"></div>

          <div className="space-y-8 relative z-10">
            <p className="text-[15px] text-[#3A3A3A] leading-[1.8]">
              Este sitio puede contener enlaces de afiliado.
            </p>
            <p className="text-[15px] text-[#3A3A3A] leading-[1.8]">
              Si el usuario realiza una compra a través de dichos enlaces, el titular puede
              recibir una comisión sin que ello suponga un coste adicional para el usuario.
            </p>
            <p className="text-[15px] text-[#3A3A3A] leading-[1.8]">
              LunaFinds recomienda únicamente productos seleccionados bajo criterio propio.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
